import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useItensCotados from "core/features/orcamento/hooks/useItensCotados";

export interface SelectItensCotadosProps<T = any>
  extends SelectBaseAntdProps<T> {
  orcamentoId: string;
}

function SelectItensCotados({ orcamentoId, ...rest }: SelectItensCotadosProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useItensCotados(orcamentoId);

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione um item"
      searchValue={search}
      showSearch
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
        unidadeMedidaId: item.unidadeMedidaId,
        quantidade: item.quantidade,
      }))}
      {...rest}
    />
  );
}

export default SelectItensCotados;
